var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audio",attrs:{"src":"https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202207261034477945516.mp3"}})
}
var staticRenderFns = []

export { render, staticRenderFns }